import Img from './Img';

export default (props) => {
  return (
    <a href="https://duet.onelink.me/GBnZ/t3682sma" target="_blank" rel="noreferrer" suppressHydrationWarning>
      <Img {...props} />
    </a>
  );
};
